import styled from '@emotion/styled';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { withConfig } from 'src/withConfig';

interface PlacesRaceSummaryRowHeaderPropsType {
    isNonRunner?: boolean;
}

export const PlacesRaceSummaryRowHeader = withConfig(theme => styled('li', { label: 'PlacesRaceSummaryRowHeader' })<PlacesRaceSummaryRowHeaderPropsType>`
    background-color: ${theme.star.raceSummary.bgColor};
    color: ${theme.star.raceSummary.txtColor};
    border-color: ${theme.star.raceSummary.borderColor};
    border-width: 0 0 1px 0;
    border-style: solid;
    display: flex;
    flex-flow: row nowrap;
    min-height: 48px;
    justify-content: space-between;
    opacity: ${({ isNonRunner }): number => isNonRunner === true ? 0.4 : 1};
    pointer-events: ${({ isNonRunner }): string => isNonRunner === true ? 'none' : 'initial'};
    user-select: ${({ isNonRunner }): string => isNonRunner === true ? 'none' : 'initial'};
    position: relative;
    @media ${theme.star.mediaQuery.tablet} {
        border-width: 0 1px 1px 1px;
        min-height: 56px;
    }
`);

export const PlaceCell = withConfig(theme => styled('div', { label: 'PlaceCell' })`
    align-items: center;
    border-right: 1px solid ${theme.star.raceSummary.borderColor};
    display: flex;
    flex-flow: column nowrap;
    flex: 0 0 24px;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    text-align: center;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 32px;
    }
`);


export const SilkRaceSummaryHrWrapper = withConfig(theme => styled('div', { label: 'SilkRaceSummaryHrWrapper' })`
    align-items: center;
    border-right: 1px solid ${theme.star.raceSummary.borderColor};
    display: flex;
    flex: 0 0 40px;
    justify-content: center;
    img[src*='empty-hr-silk'] {
        width: 24px;
    }
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 65px;
    }
`);

export const SilkRaceSummary = styled(LazyImageSilk, { label: 'SilkRaceSummary' })`
    width: 29px;
`;

export const ExtraPlacesRunnerCell = withConfig(theme => styled('div', { label: 'ExtraPlacesRunnerCell' })`
    display: flex;
    font-size: ${theme.star.fontSize.xSmall};
    flex: 1 1 auto;
    align-items: flex-start;
    flex-flow: column nowrap;
    justify-content: center;
`);
